import React from 'react';
import { string } from 'prop-types';
import I18n from 'i18n-js';
import { Flex, Layout } from 'antd';
import { CwoCountryLogo } from 'components/cwo-icons';

const { Header } = Layout;

/** Provides company branding for anonymous public pages. */
export const SharedLinkHeader = ({ currentCountry }) => (
  <Header className="navigation-top-menu shared-link-page__header">
    <Flex role="img" aria-label={I18n.t('shared_links.brand')}>
      <CwoCountryLogo country={currentCountry} />
    </Flex>
  </Header>
);

SharedLinkHeader.propTypes = {
  currentCountry: string.isRequired,
};
